import {
  toSectionCtaSingle,
  toSectionFeature,
  toSectionSlider
} from '@/lib/transformers'
import { Typo3SectionSpotSanitySport } from '@/types/typo3'
import {
  SpotSanityDetail,
  SpotSanityList
} from '@/ui/components/SpotSanity/SpotSanity'
import { SectionCtaSingle, SectionFeature, SectionSlider } from '@/ui/Sections'
import { memo, Suspense } from 'react'

interface Props {
  data: Typo3SectionSpotSanitySport
}

const SpotSanitySport = ({ data }: Props) => {
  const layout = data?.plugin?.layout

  switch (layout) {
    case 'horizontal-with-images': {
      const sectionData = toSectionFeature(data)
      return <SectionFeature {...sectionData} />
    }
    case 'photo-big': {
      const sectionData = toSectionCtaSingle(data)
      return <SectionCtaSingle {...sectionData} />
    }
    case 'photo-big-slide': {
      const sectionData = toSectionSlider(data)
      return <SectionSlider {...sectionData} />
    }
    case 'detail': {
      return <SpotSanityDetail data={data} />
    }
    default: {
      return (
        <Suspense>
          <SpotSanityList data={data} storeType="culture" />
        </Suspense>
      )
    }
  }
}

export default memo(SpotSanitySport)
